<script setup>
import InputCheckbox    from "@/components/form/InputCheckbox.vue";

const props = defineProps({
  errors: Object,
  inputs: Object,
  eIds: Object,
  validators: Object,
});
</script>
<template>
  <div>
    <div v-show="eIds.personalForms.length + eIds.mpaForms.length + eIds.teamForms.length <= 1">
      <InputCheckbox
        v-model="inputs.cbAckLegalPersSingleMembership"
        name="cbAckLegalPersSingleMembership"
        :error="errors.cbAckLegalPersSingleMembership"
        @validate="(event) => validators.checked(event)"
        >
          <template v-slot:label>
            <i18n-t keypath="contractDetail.forPersonal.cbAckLegalPersSingleMembership" tag="p" scope="global">
              <template v-slot:cbAckLegalPersSingleMembershipContract>
                <a class="text-primary" target="_blank" rel="noreferrer noopener nofollow" :href="$t('contractDetail.forPersonal.cbAckLegalPersSingleMembershipContractLink')">
                  {{ $t("contractDetail.forPersonal.cbAckLegalPersSingleMembershipContract") }}
                </a>
              </template>
            </i18n-t>
          </template>
        </InputCheckbox>
      <InputCheckbox
        v-model="inputs.cbAckLegalPersSinglePersonallyResponsible"
        name="cbAckLegalPersSinglePersonallyResponsible"
        :label="$t('contractDetail.forPersonal.cbAckLegalPersSinglePersonallyResponsible')"
        :error="errors.cbAckLegalPersSinglePersonallyResponsible"
        @validate="(event) => validators.checked(event)"
      />
    </div>
    <div v-show="eIds.personalForms.length + eIds.mpaForms.length + eIds.teamForms.length > 1">
      <InputCheckbox
        v-model="inputs.cbAckLegalPersCollectiveMembership"
        name="cbAckLegalPersCollectiveMembership"
        :error="errors.cbAckLegalPersCollectiveMembership"
        @validate="(event) => validators.checked(event)"
        >
          <template v-slot:label>
            <i18n-t keypath="contractDetail.forPersonal.cbAckLegalPersCollectiveMembership" tag="p" scope="global">
              <template v-slot:cbAckLegalPersCollectiveMembershipContract>
                <a class="text-primary" target="_blank" rel="noreferrer noopener nofollow" :href="$t('contractDetail.forPersonal.cbAckLegalPersCollectiveMembershipContractLink')">
                  {{ $t("contractDetail.forPersonal.cbAckLegalPersCollectiveMembershipContract") }}
                </a>
              </template>
            </i18n-t>
          </template>
        </InputCheckbox>
      <InputCheckbox
        v-model="inputs.cbAckLegalPersCollectivePersonallyResponsible"
        name="cbAckLegalPersCollectivePersonallyResponsible"
        :label="$t('contractDetail.forPersonal.cbAckLegalPersCollectivePersonallyResponsible')"
        :error="errors.cbAckLegalPersCollectivePersonallyResponsible"
        @validate="(event) => validators.checked(event)"
      />
    </div>
  </div>
</template>
